import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=d03e8704&scoped=true"
import script from "./ContactsSection.vue?vue&type=script&lang=js"
export * from "./ContactsSection.vue?vue&type=script&lang=js"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&id=d03e8704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03e8704",
  null
  
)

export default component.exports